import {Injectable, InjectionToken} from "@angular/core";

export const APP_ENVIRONMENT = new InjectionToken<any>('App Environment');

